import HttpMethods from '../enums/HttpMethods'
import WebService from './WebService'
// Enums
import PROFILES from "../enums/ProfileEnum";
import {getDistinctValues} from "../utils/JSUtils";
import T from 'i18n-react';

class UserService {

    /**
     * Change le mdp d'un utilisateur
     * @param keyPass
     * @param login
     * @param password
     * @returns {*}
     */
    setNewPassword(keyPass, login, password) {
        return WebService.call(`/api/login/keypass/${keyPass}`, HttpMethods.POST, {'login': login, 'password': password})
    }


    /**
     * Méthode qui pêrmet de construire les infos de l'utilisateur pour Google Analytics (id User et dimensions personnalisées)
     * Les dimensions personnalisée et leur index sont définis dans la console Google Analytics
     * @param user
     * @returns {{dimension1: *, dimension4: *, userId: null, dimension5: *, dimension2: *, dimension3}}
     */
    getGoogleAnalyticsCustomInfo(user) {
        if( !!user) {
            const userId = user ? user.idUser : null;
            let client = null;
            if(user.clientList && user.clientList.length === 1) {
                client = [user.clientList[0].id, user.clientList[0].codeClient, user.clientList[0].name].join('-');
            }
            const profile = user.profile ? T.translate("userProfile." + user.profile) : null;

            const country = user.locationList && Array.isArray(user.locationList) ? user.locationList.join(", ") : null;

            let businessUnit = null;
            if(user.businessUnitList && user.businessUnitList.length === 1) {
                businessUnit = [user.businessUnitList[0].id, user.businessUnitList[0].codeBu, user.businessUnitList[0].name].join('-');
            }

            let shop = null;
            if(user.shopList && user.shopList.length === 1) {
                shop = [user.shopList[0].id, user.shopList[0].codeAl, user.shopList[0].name].join('-');
            }

            return {
                userId,
                dimension1: client,
                dimension2: profile,
                dimension3: country,
                dimension4: businessUnit,
                dimension5: shop
            }
        }
    }

    /**
     * Service de renouvellement de mdp
     * @param login
     * @returns {*}
     */
    sendKeypass(login) {
        return WebService.call('/api/login/keypass', HttpMethods.POST, {'login' : login})
    }

    /**
     * Ajoute un utilisateur en base
     * @returns {*}
     */
    addUser(userData) {
        return WebService.call('/api/user', HttpMethods.POST, userData);
    }

    /**
     * Récupère un utilisateur en base
     * @param idUser
     */
    getUser(idUser) {
        return WebService.call(`/api/user/${idUser}`, HttpMethods.GET);
    }

    /**
     * Modifie un utilisateur en base
     * @param userData
     * @returns {*}
     */
    editUser(userData) {
        return WebService.call(`/api/user/${userData.id}`, HttpMethods.POST, userData);
    }

    /**
     * Supprime un utilisateur en base
     * @param idUser
     * @returns {*}
     */
    deleteUser(idUser) {
        return WebService.call(`/api/user/${idUser}`, HttpMethods.DELETE);
    }

    /**
     * Modifie les informations du compte
     * @param userData
     * @return {*}
     */
    editMyUserInformation(userData) {
        return WebService.call('/api/user/my', HttpMethods.POST, userData);
    }   

    /**
     * Modifie le mot de passe de l'utilisateur
     * @param {*} oldPassword 
     * @param {*} newPassword 
     */
    editPassword(oldPassword, newPassword) {
        return WebService.call('/api/user/passwd', HttpMethods.POST, {'oldPassword': oldPassword, 'newPassword' : newPassword});
    }

    /**
     * Récupère la liste des shops avec ses utilisateurs associés
     * (il faut être admin ou user manager)
     */
    getUserInformationList(page, length = 0, profile, search, sort, columnToSortList) {
        let url = `/api/user?page=${page}&length=${length}`;
        url += profile ? `&profile=${profile}` : '';
        url += search ? `&search=${search}` : '';
        url += sort ? `&sort=${sort}` : '';
        url += columnToSortList ? `&columnToSortList=${columnToSortList}` : '';
       
        return WebService.call(url, HttpMethods.GET, null);
    }

    /** 
     * Récupère la liste total des users
    */
    getUserInformationListForExport() {
        return WebService.call('/api/user', HttpMethods.GET, null)
    }

    /**
     * Récupère les informations sur l'utilisateur (profile)
     * @returns {*}
     */
    getUserInformation() {
        return WebService.call('/api/user/information', HttpMethods.GET, null);
    }

    //Séléction des profils accessibles à un utilisateur
    getAvailableProfileForUser = (userProfile) => {
        //Un utilisateur a accès à tous les profils inférieurs ou équivalents au sien
        switch (userProfile) {
            case PROFILES.ADMIN_MP:
                return [PROFILES.ADMIN_MP, PROFILES.ADMIN, PROFILES.SUPER_USER, PROFILES.USER];
            case PROFILES.ADMIN:
                return [PROFILES.ADMIN, PROFILES.SUPER_USER, PROFILES.USER];
            case PROFILES.SUPER_USER:
                return [PROFILES.SUPER_USER, PROFILES.USER];
            case PROFILES.USER:
                return [PROFILES.USER];
            default:
                //Par défaut, on autorise que les User
                return [PROFILES.USER];
        }
    };

    //Vérification qu'un utilisateur a le droit de modifier l'accès à la gestion des utilisateurs pour un autre utilisateur
    //Un utilisateur peut modifier les droits des profils strictement inférieurs
    canEditManagementRights = (requesterProfile, userProfile) => {
        let profilesMap = this.getAvailableProfileForUser(requesterProfile);
        //On retire le profil de l'utilisateur connecté
        profilesMap = profilesMap.filter(profile => profile !== requesterProfile);
        return profilesMap.includes(userProfile);
    }

    /**
     * Récupère les valeurs par défaut des entités de l'utilisateur
     * Si une liste n'a qu'un élément, on renvoie cet élément et on vérifie la de la liste suivante
     * @returns {*}
     */
    initUserEntities(clientList, buList, shopList, filters){
        //Extraction de la listes des pays différents dans la liste de clients
        const locationList = getDistinctValues(clientList.map(client => client.location));
        let location = null;
        let client = null;
        let bu = null;
        let shop = null;
        let paymentType = null;
        let activity = null;
        if(locationList.length === 1){
            location = locationList[0];
            if(clientList && clientList.length === 1){
                client = clientList[0];
                if(buList && buList.length === 1){
                    bu = buList[0];
                    if(shopList && shopList.length === 1){
                        shop = shopList[0];
                    }
                }
            }
        }
        if (filters) {
            if (filters.location) {
                location = filters.location[0];
            }
            if(filters.selectedClient){
                client = this.getItemInList(filters.selectedClient[0], clientList);
                if(filters.selectedBu){
                    bu = this.getItemInList(filters.selectedBu[0], buList);
                    if(filters.selectedShop){
                        let name = filters.selectedShop[0].name;
                        if (filters.selectedShop[0].name.indexOf(' - ') !== -1) {
                            name = filters.selectedShop[0].name.split(' - ')[1];
                        }
                        shop = this.getItemInList({name: name});
                    }
                }
            }
            if (filters.selectedPaymentType) {
                paymentType = filters.selectedPaymentType;
            }
            if (filters.selectedActivity) {
                activity = filters.selectedActivity;
            }
        }
        return {
            location,
            client,
            bu,
            shop,
            paymentType,
            activity
        }
    }

    getItemInList(value, list) {
        if (list && value.name) {
            return list.find(item => item.name === value.name)
        }

        return null
    }

    isUserDataValid(userData) {
        return userData.clientList.length > 0 && userData.businessUnitList.length > 0 && userData.shopList.length > 0;
    }

}

export default new UserService();



// WEBPACK FOOTER //
// ./src/services/UserService.js